import { render, staticRenderFns } from "./Verse.vue?vue&type=template&id=5fa54992&scoped=true&"
import script from "./Verse.vue?vue&type=script&lang=js&"
export * from "./Verse.vue?vue&type=script&lang=js&"
import style0 from "./Verse.vue?vue&type=style&index=0&id=5fa54992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa54992",
  null
  
)

export default component.exports